/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtReportTemplate.id.label': '主键',
'tqtReportTemplate.id.holder': '请输入主键',
'tqtReportTemplate.id.max': '主键最多11个字符',
'tqtReportTemplate.id.required': '主键必填',
'tqtReportTemplate.searchId.holder': '搜索主键',
'tqtReportTemplate.name.label': '模板名称（主标题）',
'tqtReportTemplate.name.holder': '请输入模板名称（主标题）',
'tqtReportTemplate.name.max': '模板名称（主标题）最多54个字符',
'tqtReportTemplate.name.required': '模板名称（主标题）必填',
'tqtReportTemplate.searchName.holder': '搜索模板名称（主标题）',
'tqtReportTemplate.isEnable.label': '是否启用（0启用，1不启用）',
'tqtReportTemplate.isEnable.holder': '请输入是否启用（0启用，1不启用）',
'tqtReportTemplate.isEnable.max': '是否启用（0启用，1不启用）最多1个字符',
'tqtReportTemplate.isEnable.required': '是否启用（0启用，1不启用）必填',
'tqtReportTemplate.searchIsEnable.holder': '搜索是否启用（0启用，1不启用）',
'tqtReportTemplate.createTime.label': '创建时间',
'tqtReportTemplate.createTime.holder': '请输入创建时间',
'tqtReportTemplate.createTime.max': '创建时间最多null个字符',
'tqtReportTemplate.createTime.required': '创建时间必填',
'tqtReportTemplate.searchCreateTime.holder': '搜索创建时间',
'tqtReportTemplate.formTableName.label': '单个模板在数据库的具体表名',
'tqtReportTemplate.formTableName.holder': '请输入单个模板在数据库的具体表名',
'tqtReportTemplate.formTableName.max': '单个模板在数据库的具体表名最多54个字符',
'tqtReportTemplate.formTableName.required': '单个模板在数据库的具体表名必填',
'tqtReportTemplate.searchFormTableName.holder': '搜索单个模板在数据库的具体表名',
'tqtReportTemplate.url.label': '跳转链接',
'tqtReportTemplate.url.holder': '请输入跳转链接',
'tqtReportTemplate.url.max': '跳转链接最多255个字符',
'tqtReportTemplate.url.required': '跳转链接必填',
'tqtReportTemplate.searchUrl.holder': '搜索跳转链接',
'tqtReportTemplate.subtitle.label': '副标题',
'tqtReportTemplate.subtitle.holder': '请输入副标题',
'tqtReportTemplate.subtitle.max': '副标题最多255个字符',
'tqtReportTemplate.subtitle.required': '副标题必填',
'tqtReportTemplate.searchSubtitle.holder': '搜索副标题',
'tqtReportTemplate.pic.label': '图片相对路径',
'tqtReportTemplate.pic.holder': '请输入图片相对路径',
'tqtReportTemplate.pic.max': '图片相对路径最多255个字符',
'tqtReportTemplate.pic.required': '图片相对路径必填',
'tqtReportTemplate.searchPic.holder': '搜索图片相对路径',
'tqtReportTemplate.adminId.label': '操作人id',
'tqtReportTemplate.adminId.holder': '请输入操作人id',
'tqtReportTemplate.adminId.max': '操作人id最多11个字符',
'tqtReportTemplate.adminId.required': '操作人id必填',
'tqtReportTemplate.searchAdminId.holder': '搜索操作人id',
'tqtReportTemplate.updateTime.label': '更新时间',
'tqtReportTemplate.updateTime.holder': '请输入更新时间',
'tqtReportTemplate.updateTime.max': '更新时间最多null个字符',
'tqtReportTemplate.updateTime.required': '更新时间必填',
'tqtReportTemplate.searchUpdateTime.holder': '搜索更新时间',
},
'zh-TW': {
'tqtReportTemplate.id.label': '主键',
'tqtReportTemplate.id.holder': '請輸入主键',
'tqtReportTemplate.id.max': '主键最多11個字符',
'tqtReportTemplate.id.required': '主键必填',
'tqtReportTemplate.searchId.holder': '搜索主键',
'tqtReportTemplate.name.label': '模板名称（主标题）',
'tqtReportTemplate.name.holder': '請輸入模板名称（主标题）',
'tqtReportTemplate.name.max': '模板名称（主标题）最多54個字符',
'tqtReportTemplate.name.required': '模板名称（主标题）必填',
'tqtReportTemplate.searchName.holder': '搜索模板名称（主标题）',
'tqtReportTemplate.isEnable.label': '是否启用（0启用，1不启用）',
'tqtReportTemplate.isEnable.holder': '請輸入是否启用（0启用，1不启用）',
'tqtReportTemplate.isEnable.max': '是否启用（0启用，1不启用）最多1個字符',
'tqtReportTemplate.isEnable.required': '是否启用（0启用，1不启用）必填',
'tqtReportTemplate.searchIsEnable.holder': '搜索是否启用（0启用，1不启用）',
'tqtReportTemplate.createTime.label': '创建时间',
'tqtReportTemplate.createTime.holder': '請輸入创建时间',
'tqtReportTemplate.createTime.max': '创建时间最多null個字符',
'tqtReportTemplate.createTime.required': '创建时间必填',
'tqtReportTemplate.searchCreateTime.holder': '搜索创建时间',
'tqtReportTemplate.formTableName.label': '单个模板在数据库的具体表名',
'tqtReportTemplate.formTableName.holder': '請輸入单个模板在数据库的具体表名',
'tqtReportTemplate.formTableName.max': '单个模板在数据库的具体表名最多54個字符',
'tqtReportTemplate.formTableName.required': '单个模板在数据库的具体表名必填',
'tqtReportTemplate.searchFormTableName.holder': '搜索单个模板在数据库的具体表名',
'tqtReportTemplate.url.label': '跳转链接',
'tqtReportTemplate.url.holder': '請輸入跳转链接',
'tqtReportTemplate.url.max': '跳转链接最多255個字符',
'tqtReportTemplate.url.required': '跳转链接必填',
'tqtReportTemplate.searchUrl.holder': '搜索跳转链接',
'tqtReportTemplate.subtitle.label': '副标题',
'tqtReportTemplate.subtitle.holder': '請輸入副标题',
'tqtReportTemplate.subtitle.max': '副标题最多255個字符',
'tqtReportTemplate.subtitle.required': '副标题必填',
'tqtReportTemplate.searchSubtitle.holder': '搜索副标题',
'tqtReportTemplate.pic.label': '图片相对路径',
'tqtReportTemplate.pic.holder': '請輸入图片相对路径',
'tqtReportTemplate.pic.max': '图片相对路径最多255個字符',
'tqtReportTemplate.pic.required': '图片相对路径必填',
'tqtReportTemplate.searchPic.holder': '搜索图片相对路径',
'tqtReportTemplate.adminId.label': '操作人id',
'tqtReportTemplate.adminId.holder': '請輸入操作人id',
'tqtReportTemplate.adminId.max': '操作人id最多11個字符',
'tqtReportTemplate.adminId.required': '操作人id必填',
'tqtReportTemplate.searchAdminId.holder': '搜索操作人id',
'tqtReportTemplate.updateTime.label': '更新时间',
'tqtReportTemplate.updateTime.holder': '請輸入更新时间',
'tqtReportTemplate.updateTime.max': '更新时间最多null個字符',
'tqtReportTemplate.updateTime.required': '更新时间必填',
'tqtReportTemplate.searchUpdateTime.holder': '搜索更新时间',
},
'en-US': {
'tqtReportTemplate.id.label': '主键',
'tqtReportTemplate.id.holder': 'Enter 主键',
'tqtReportTemplate.id.max': '主键 max length: 11',
'tqtReportTemplate.id.required': '主键 required',
'tqtReportTemplate.searchId.holder': 'Search 主键',
'tqtReportTemplate.name.label': '模板名称（主标题）',
'tqtReportTemplate.name.holder': 'Enter 模板名称（主标题）',
'tqtReportTemplate.name.max': '模板名称（主标题） max length: 54',
'tqtReportTemplate.name.required': '模板名称（主标题） required',
'tqtReportTemplate.searchName.holder': 'Search 模板名称（主标题）',
'tqtReportTemplate.isEnable.label': '是否启用（0启用，1不启用）',
'tqtReportTemplate.isEnable.holder': 'Enter 是否启用（0启用，1不启用）',
'tqtReportTemplate.isEnable.max': '是否启用（0启用，1不启用） max length: 1',
'tqtReportTemplate.isEnable.required': '是否启用（0启用，1不启用） required',
'tqtReportTemplate.searchIsEnable.holder': 'Search 是否启用（0启用，1不启用）',
'tqtReportTemplate.createTime.label': '创建时间',
'tqtReportTemplate.createTime.holder': 'Enter 创建时间',
'tqtReportTemplate.createTime.max': '创建时间 max length: null',
'tqtReportTemplate.createTime.required': '创建时间 required',
'tqtReportTemplate.searchCreateTime.holder': 'Search 创建时间',
'tqtReportTemplate.formTableName.label': '单个模板在数据库的具体表名',
'tqtReportTemplate.formTableName.holder': 'Enter 单个模板在数据库的具体表名',
'tqtReportTemplate.formTableName.max': '单个模板在数据库的具体表名 max length: 54',
'tqtReportTemplate.formTableName.required': '单个模板在数据库的具体表名 required',
'tqtReportTemplate.searchFormTableName.holder': 'Search 单个模板在数据库的具体表名',
'tqtReportTemplate.url.label': '跳转链接',
'tqtReportTemplate.url.holder': 'Enter 跳转链接',
'tqtReportTemplate.url.max': '跳转链接 max length: 255',
'tqtReportTemplate.url.required': '跳转链接 required',
'tqtReportTemplate.searchUrl.holder': 'Search 跳转链接',
'tqtReportTemplate.subtitle.label': '副标题',
'tqtReportTemplate.subtitle.holder': 'Enter 副标题',
'tqtReportTemplate.subtitle.max': '副标题 max length: 255',
'tqtReportTemplate.subtitle.required': '副标题 required',
'tqtReportTemplate.searchSubtitle.holder': 'Search 副标题',
'tqtReportTemplate.pic.label': '图片相对路径',
'tqtReportTemplate.pic.holder': 'Enter 图片相对路径',
'tqtReportTemplate.pic.max': '图片相对路径 max length: 255',
'tqtReportTemplate.pic.required': '图片相对路径 required',
'tqtReportTemplate.searchPic.holder': 'Search 图片相对路径',
'tqtReportTemplate.adminId.label': '操作人id',
'tqtReportTemplate.adminId.holder': 'Enter 操作人id',
'tqtReportTemplate.adminId.max': '操作人id max length: 11',
'tqtReportTemplate.adminId.required': '操作人id required',
'tqtReportTemplate.searchAdminId.holder': 'Search 操作人id',
'tqtReportTemplate.updateTime.label': '更新时间',
'tqtReportTemplate.updateTime.holder': 'Enter 更新时间',
'tqtReportTemplate.updateTime.max': '更新时间 max length: null',
'tqtReportTemplate.updateTime.required': '更新时间 required',
'tqtReportTemplate.searchUpdateTime.holder': 'Search 更新时间',
}
};